import React from 'react'
import { Form } from 'reactstrap';
import { AlertTriangle } from "react-feather";

export const DeleteCompany = (props) => {

    const {
        name, code
    } = props;

    return (
        <Form className="theme-form" role="form" >
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                marginBottom: "15px"
            }}>
                <div style={{
                    backgroundColor: "#ffe6e6",
                    borderRadius: "50%",
                    width: "80px",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <AlertTriangle size={28} color="#c92a2a" />
                </div>

                <div>
                    <p
                        className="mb-0"
                        style={{
                            fontSize: "13px",
                            color: "#0d3b59"
                        }}
                    >
                        Esta acción no se puede deshacer. ¿Estás seguro de eliminar al cliente?
                    </p>
                </div>
            </div>

            <div style={{
                background: "#f8fbff",
                padding: "12px 14px",
                borderRadius: "8px",
                border: "1px solid #d7e7f5",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <span style={{ fontWeight: 500, color: "#0d3b59" }}>
                    {code + " " + name}
                </span>
            </div>


            <br />

        </Form>
    )
}
